// AmenitiesGrid.js
import React from 'react';
import { Grid, Typography, Box, useMediaQuery, useTheme } from '@mui/material';
import AmenityCard from './AmenityCard';
import { getFallbackIcon, getIconForTheText } from '../../../assets/iconMapping';
import AmenitiesGridSkeleton from './AmenitiesGridSkeleton';

const AmenitiesGrid = ({ amenities, loading }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  if (loading) return <AmenitiesGridSkeleton />;
  if (!amenities?.length) {
    return (
      <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem" }}>
        No amenities listed
      </Typography>
    );
  }

  return (
    <Box>
      <Grid container spacing={2}>
        {amenities.map((amenity, index) => (
          <Grid 
            item 
            xs={6} 
            sm={4} 
            md={3} 
            key={index}
            sx={{
              '&:hover': {
                transform: 'translateY(-2px)',
                transition: 'transform 0.2s ease'
              }
            }}
          >
            <AmenityCard 
              icon={getIconForTheText(amenity) || getFallbackIcon()} 
              label={amenity}
              compact={isSmallScreen}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AmenitiesGrid;
